<template>
  <div>
    <div class="d-flex align-center">
      <v-text-field
        label="Recherchez par numero de permis"
        append-icon="mdi-magnify"
        v-model="numeroPermis"
        outlined
        :disabled="updating"
        :loading="updating"
        @click:append="search"
        @keydown.enter="search"
        @blur="search"
        style="max-width: 400px"
        autocomplete="nope"
      ></v-text-field>
    </div>
    <v-alert text border="left" type="info" v-show="this.errorMessage">{{ this.errorMessage }}</v-alert>

    <v-dialog v-model="dialog" width="700">
      <v-card class="pa-6">
        <h2 class="headline mb-3">Résultats</h2>
        <p>Sélectionnez votre contact dans la liste. S'il n'est pas répertorié, continuez le formulaire.</p>
        <v-card v-for="contact in result" :key="contact.id" @click="contactSelected(contact)" class="pa-6 mb-3" outlined max-width="450">
          <h3>{{ contact.numeroPermis }}</h3>
          <p class="mb-0 caption">{{ contact.prenom }} {{ contact.nom }}</p>
        </v-card>
        <div class="text-center mt-6">
          <v-btn color="primary" @click="dialog = false">Mon contact n'est pas répertorié</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { findByNumeroPermis } from "@/plugins/services/contacts"
import CataloguesHelper from "@/mixins/CataloguesHelpers"
export default {
  mixins: [CataloguesHelper],
  data() {
    return {
      numeroPermis: "",
      updating: false,
      result: [],
      errorMessage: "",
      dialog: false
    }
  },
  methods: {
    search() {
      if (!this.numeroPermis) {
        return
      }
      this.result = []
      this.updating = true

      findByNumeroPermis(this.numeroPermis)
        .then((res) => {
          this.result = res.data
          if (this.result.length == 0) {
            this.errorMessage = "Aucun contact trouvé, essayez un autre numero de permis."
          } else {
            this.dialog = true
            this.errorMessage = ""
          }
        })
        .catch((err) => {
          this.result = []
          this.errorMessage = err.response.data.message
        })
        .finally(() => {
          this.updating = false
        })
    },
    contactSelected(contact) {
      this.$emit("contact-selected", contact)
      this.numeroPermis = contact.numeroPermis
      this.dialog = false
    }
  }
}
</script>

<style>
</style>